"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _dialog_props = require("./dialog_props");

var _dom_component = _interopRequireDefault(require("./component/dom_component"));

var _dialog_compact_props = _interopRequireDefault(require("./dialog_compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 用于存储页面当前哪些弹框打开着
var openDialogIds = [];

var updateOpenDialogIds = function updateOpenDialogIds(dialogId) {
  var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = (0, _spauiUtils.indexOf)(openDialogIds, dialogId);

  if (show) {
    if (index < 0) {
      openDialogIds.push(dialogId);
    }
  } else {
    if (index > -1) {
      openDialogIds.splice(index, 1);
    }
  }
};
/**
 * @class
 */


var Dialog =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dialog, _PureComponent);

  function Dialog(props) {
    var _this;

    _classCallCheck(this, Dialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dialog).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleMouseDownInHeader", function (event) {
      // 如果没有标注特定模式，则默认为移动对话框
      if (!_this.mode) {
        _this.mode = 'move';
        document.body.originalClassName = document.body.className;
        document.body.className = "".concat(document.body.originalClassName, " dragging");
      }

      _this.markMoveAndResizeStart(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDownInContent", function (event) {
      if (_this.mode) {
        _this.markMoveAndResizeStart(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMoveInWindow", function (event) {
      var _this$props$resize = _this.props.resize,
          resize = _this$props$resize === void 0 ? false : _this$props$resize; // 如果正处于某种处理的过程中，则继续

      if (_this.mode && _this.enabled) {
        _this.moveAndResizeProgress(event);
      } else if (_this.isOnTop() && resize) {
        // 否则检测后续的操作模式（仅针对顶层对话框）
        _this.detectMoveAndResizeMode(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUpInWindow", function () {
      if (!_this.mode || !_this.enabled) {
        return;
      }

      _this.markMoveAndResizeFinish();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props$escHide = _this.props.escHide,
          escHide = _this$props$escHide === void 0 ? false : _this$props$escHide;
      var show = _this.state.show; // 展示的时候按回车键相等于关闭，只关闭最新打开的那一个弹框

      if (show && escHide && event.keyCode === 27 && openDialogIds[openDialogIds.length - 1] === _this.id) {
        _this.handleClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (event) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          show = _this$props.show;

      if ((0, _spauiUtils.isUndefined)(show)) {
        _this.hide();
      }

      if ((0, _spauiUtils.isFunction)(onClose) || (0, _spauiUtils.isAsyncFunction)(onClose)) {
        // 提供内置关闭的函数
        onClose(event, function () {
          _this.hide();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          show = _this$props2.show;

      if ((0, _spauiUtils.isUndefined)(show)) {
        _this.hide();
      }

      if ((0, _spauiUtils.isFunction)(onSubmit) || (0, _spauiUtils.isAsyncFunction)(onSubmit)) {
        onSubmit(event, function () {
          _this.hide();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function (event) {
      var _this$props3 = _this.props,
          onCancel = _this$props3.onCancel,
          show = _this$props3.show;

      if ((0, _spauiUtils.isUndefined)(show)) {
        _this.hide();
      }

      if ((0, _spauiUtils.isFunction)(onCancel) || (0, _spauiUtils.isAsyncFunction)(onCancel)) {
        onCancel(event, function () {
          _this.hide();
        });
      }
    });

    _this.state = {
      show: (0, _spauiUtils.isUndefined)(props.show) ? true : props.show,
      tipExitAnimation: false,
      // 显示 tip 离开的动画
      tipEnterAnimation: false // 显示 tip 进入的动画

    }; // 给每个弹框设置一个id，方便针对多弹框处理多时候有个判断依据

    _this.id = (0, _spauiUtils.getUniqueId)('spaui-dialog');
    _this.timeout = null;
    return _this;
  }

  _createClass(Dialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var useNewUI = this.props.useNewUI;
      updateOpenDialogIds(this.id, this.state.show);
      this.hideTip();
      this.addEventListenKeyDown(); // 新版 UI 使用 CSS 来定位，且暂时不支持拖拽

      if (!useNewUI) {
        this.addListenMoveAndResize();
      }

      this.triggerSubscribe(); // 检查css与js版本是否正确

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!(0, _spauiUtils.isUndefined)(nextProps.show)) {
        // 如果是true的话，就在这里先记录一下
        if (nextProps.show) {
          updateOpenDialogIds(this.id, nextProps.show);
        }

        if (nextProps.show) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var show = this.state.show;
      var useNewUI = this.props.useNewUI;
      updateOpenDialogIds(this.id, show);
      this.hideTip(); // 关闭的时候就去掉监听函数

      if (!useNewUI) {
        if (show) {
          this.addListenMoveAndResize();
        } else {
          this.removeListenMoveAndResize();
        }
      }

      this.triggerSubscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var useNewUI = this.props.useNewUI;
      updateOpenDialogIds(this.id, false);
      this.removeEventListenKeyDown();

      if (!useNewUI) {
        this.removeListenMoveAndResize();
      }

      this.triggerSubscribe(true);
      clearTimeout(this.timeout);
    } // 触发订阅函数

  }, {
    key: "triggerSubscribe",
    value: function triggerSubscribe() {
      var isUnmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var subscribeChange = this.props.subscribeChange;

      if ((0, _spauiUtils.isFunction)(subscribeChange)) {
        subscribeChange(_objectSpread({}, this.props, {
          show: isUnmount ? false : this.state.show
        }), this);
      }
    } // 添加监听拖动与resize

  }, {
    key: "addListenMoveAndResize",
    value: function addListenMoveAndResize() {
      var _this$props4 = this.props,
          _this$props4$moveable = _this$props4.moveable,
          moveable = _this$props4$moveable === void 0 ? false : _this$props4$moveable,
          _this$props4$resize = _this$props4.resize,
          resize = _this$props4$resize === void 0 ? false : _this$props4$resize;
      var show = this.state.show;
      var contentEl = null;

      if (show && (moveable || resize) && !this.isListenMoveAndResize && this.dialogRef && this.dialogRef.modal) {
        contentEl = this.dialogRef.modal.querySelector('.modal-content');

        if (contentEl) {
          window.addEventListener('mousemove', this.handleMouseMoveInWindow);

          if (moveable) {
            // move
            contentEl.querySelector('.modal-header').addEventListener('mousedown', this.handleMouseDownInHeader);
          } // resize


          contentEl.addEventListener('mousedown', this.handleMouseDownInContent);
          this.contentEl = contentEl; // 避免重复监听，加多一个标记

          this.isListenMoveAndResize = true;
        }
      }
    }
  }, {
    key: "removeListenMoveAndResize",
    value: function removeListenMoveAndResize() {
      var _this$props$moveable = this.props.moveable,
          moveable = _this$props$moveable === void 0 ? false : _this$props$moveable;

      if (this.contentEl && this.isListenMoveAndResize) {
        if (moveable) {
          // move
          this.contentEl.querySelector('.modal-header').removeEventListener('mousedown', this.handleMouseDownInHeader);
        } // resize


        this.contentEl.removeEventListener('mousedown', this.handleMouseDownInContent);
        window.removeEventListener('mousemove', this.handleMouseMoveInWindow);
        window.removeEventListener('mouseup', this.handleMouseUpInWindow);
        this.contentEl = null;
        this.isListenMoveAndResize = false;
      }
    }
  }, {
    key: "detectMoveAndResizeMode",

    /**
     * 检测对话框的模式
     * @param e
     */
    value: function detectMoveAndResizeMode(e) {
      var _this$props$resizeTri = this.props.resizeTriggerPadding,
          PADDING = _this$props$resizeTri === void 0 ? 5 : _this$props$resizeTri;
      var contentEl = this.contentEl;
      var offsetLeft = contentEl.offsetLeft + (contentEl.offsetParent ? contentEl.offsetParent.offsetLeft : 0);
      var offsetTop = contentEl.offsetTop + (contentEl.offsetParent ? contentEl.offsetParent.offsetTop : 0);
      var offsetRight = offsetLeft + contentEl.clientWidth;
      var offsetBottom = offsetTop + contentEl.clientHeight;
      var left = e.clientX > offsetLeft && e.clientX - offsetLeft <= PADDING;
      var top = e.clientY > offsetTop && e.clientY - offsetTop <= PADDING;
      var right = left ? false : e.clientX < offsetRight && offsetRight - e.clientX <= PADDING;
      var bottom = top ? false : e.clientY < offsetBottom && offsetBottom - e.clientY <= PADDING;

      if (left || top || right || bottom) {
        var mode = "resize_".concat(left ? 'left' : '').concat(right ? 'right' : '').concat(top ? 'top' : '').concat(bottom ? 'bottom' : '');

        if (this.mode !== mode) {
          this.mode = mode;

          if (!document.body.originalClassName) {
            document.body.originalClassName = document.body.className;
          }

          document.body.className = "".concat(document.body.originalClassName, " ").concat(mode);
        }
      } else if (this.mode) {
        this.mode = undefined;
        document.body.className = document.body.originalClassName;
      }
    }
    /**
     * 记录开始信息
     * @param e
     */

  }, {
    key: "markMoveAndResizeStart",
    value: function markMoveAndResizeStart(e) {
      this.enabled = true;
      this.finish = {
        x: e.screenX,
        y: e.screenY
      };
      this.start = this.finish;
      this.base = {
        x: parseInt(this.contentEl.style.marginTop || 0, 10),
        y: parseInt(this.contentEl.style.marginLeft || 0, 10),
        w: this.contentEl.clientWidth,
        h: this.contentEl.querySelector('.modal-body').clientHeight
      };
      window.addEventListener('mouseup', this.handleMouseUpInWindow);
    }
    /**
     * 处理变换
     * @param e
     */

  }, {
    key: "moveAndResizeProgress",
    value: function moveAndResizeProgress(e) {
      var _this$props5 = this.props,
          _this$props5$resizeMi = _this$props5.resizeMinWidth,
          MIN_WIDTH = _this$props5$resizeMi === void 0 ? 100 : _this$props5$resizeMi,
          _this$props5$resizeMi2 = _this$props5.resizeMinHeight,
          MIN_HEIGHT = _this$props5$resizeMi2 === void 0 ? 40 : _this$props5$resizeMi2,
          onResize = _this$props5.onResize,
          onMove = _this$props5.onMove;
      var marginTop = this.base.x;
      var marginLeft = this.base.y;
      var resizeWidth = this.base.w;
      var resizeHeight = this.base.h;
      this.finish = {
        x: e.screenX,
        y: e.screenY
      };
      var delta = {
        x: this.finish.x - this.start.x,
        y: this.finish.y - this.start.y
      };

      if (this.mode === 'move') {
        marginTop = this.base.x + delta.y;
        marginLeft = this.base.y + delta.x;
        this.contentEl.style.marginTop = "".concat(marginTop, "px");
        this.contentEl.style.marginLeft = "".concat(marginLeft, "px");
      } else {
        if (this.mode.indexOf('left') >= 0) {
          if (this.base.w - delta.x > MIN_WIDTH) {
            marginLeft = this.base.y + delta.x;
            this.contentEl.style.marginLeft = "".concat(marginLeft, "px");
            resizeWidth = this.base.w - delta.x;
            this.contentEl.style.width = "".concat(resizeWidth, "px");
          }
        } else if (this.mode.indexOf('right') >= 0) {
          if (this.base.w + delta.x > MIN_WIDTH) {
            resizeWidth = this.base.w + delta.x;
            this.contentEl.style.width = "".concat(resizeWidth, "px");
          }
        }

        if (this.mode.indexOf('top') >= 0) {
          if (this.base.h - delta.y > MIN_HEIGHT) {
            marginTop = this.base.x + delta.y;
            this.contentEl.style.marginTop = "".concat(marginTop, "px");
            resizeHeight = this.base.h - delta.y;
            this.contentEl.querySelector('.modal-body').style.height = "".concat(resizeHeight, "px");
          }
        } else if (this.mode.indexOf('bottom') >= 0) {
          if (this.base.h + delta.y > MIN_HEIGHT) {
            resizeHeight = this.base.h + delta.y;
            this.contentEl.querySelector('.modal-body').style.height = "".concat(resizeHeight, "px");
          }
        }
      }

      if ((0, _spauiUtils.isFunction)(onResize) && (resizeWidth !== this.base.w || resizeHeight !== this.base.h)) {
        onResize(e, resizeWidth, resizeHeight);
      }

      if ((0, _spauiUtils.isFunction)(onMove) && (marginTop !== this.base.x || marginLeft !== this.base.y)) {
        onMove(e, marginTop, marginLeft);
      }
    }
    /**
     * 标注完成结果（即清理）
     */

  }, {
    key: "markMoveAndResizeFinish",
    value: function markMoveAndResizeFinish() {
      if (this.mode === 'move') {
        this.mode = undefined;
      }

      this.enabled = false;
      this.base = undefined;
      this.finish = undefined;
      this.start = undefined;
      document.body.className = document.body.originalClassName;
      window.removeEventListener('mouseup', this.handleMouseUpInWindow);
    }
  }, {
    key: "addEventListenKeyDown",
    value: function addEventListenKeyDown() {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.addEventListener) {
        window.addEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: "removeEventListenKeyDown",
    value: function removeEventListenKeyDown() {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.removeEventListener) {
        window.removeEventListener('keydown', this.handleKeyDown);
      }
    } // 提供给外面获取弹框id

  }, {
    key: "getDialogId",
    value: function getDialogId() {
      return this.id;
    } // 提供给外部获取当前页面所有展示的弹框id

  }, {
    key: "getShowDialogIds",
    value: function getShowDialogIds() {
      return openDialogIds;
    } // 当前弹框是否在最上面

  }, {
    key: "isOnTop",
    value: function isOnTop() {
      return openDialogIds[openDialogIds.length - 1] === this.id;
    } // 开启escHide的话按esc键就关闭弹框

  }, {
    key: "hideTip",
    // 如果type=tip的话，在didmount， update之后就开启计时器看看是否要消除
    value: function hideTip() {
      var _this2 = this;

      var _this$props6 = this.props,
          show = _this$props6.show,
          type = _this$props6.type,
          time = _this$props6.time,
          timeCallback = _this$props6.timeCallback,
          timeoutCallback = _this$props6.timeoutCallback,
          onClose = _this$props6.onClose;

      if (type === 'tip' && time > 0 && ((0, _spauiUtils.isUndefined)(show) || show)) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          if ((0, _spauiUtils.isFunction)(timeoutCallback)) {
            timeoutCallback();
          } else if ((0, _spauiUtils.isFunction)(timeCallback)) {
            timeCallback();
          } else {
            _this2.hide();
          }

          if ((0, _spauiUtils.isFunction)(onClose) || (0, _spauiUtils.isAsyncFunction)(onClose)) {
            onClose();
          }
        }, time);
      }
    }
  }, {
    key: "show",
    value: function show() {
      var enabledTipAnimation = this.props.enabledTipAnimation;
      this.setState({
        show: true,
        tipEnterAnimation: !!enabledTipAnimation
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this3 = this;

      var enabledTipAnimation = this.props.enabledTipAnimation; // 如果有退出动画则需要延迟显示

      if (enabledTipAnimation) {
        this.setState({
          tipExitAnimation: true,
          tipEnterAnimation: false
        }, function () {
          setTimeout(function () {
            _this3.setState({
              show: false,
              tipExitAnimation: false
            });
          }, 200);
        });
      } else {
        this.setState({
          show: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state = this.state,
          show = _this$state.show,
          tipExitAnimation = _this$state.tipExitAnimation,
          tipEnterAnimation = _this$state.tipEnterAnimation;

      var _compactProps = (0, _dialog_compact_props["default"])(this.props),
          hideScrollBar = _compactProps.hideScrollBar,
          children = _compactProps.children,
          className = _compactProps.className,
          type = _compactProps.type,
          cancelButton = _compactProps.cancelButton,
          submitButton = _compactProps.submitButton,
          FooterLeftComponent = _compactProps.FooterLeftComponent,
          title = _compactProps.title,
          _compactProps$hideFoo = _compactProps.hideFooter,
          hideFooter = _compactProps$hideFoo === void 0 ? false : _compactProps$hideFoo,
          enabledBackgroundColor = _compactProps.enabledBackgroundColor,
          enabledTipAnimation = _compactProps.enabledTipAnimation,
          tipAnimationType = _compactProps.tipAnimationType,
          tipAnimationDirection = _compactProps.tipAnimationDirection,
          useNewUI = _compactProps.useNewUI;

      return _react["default"].createElement(_dom_component["default"], _extends({}, this.props, {
        "data-dialog-id": this.id,
        originProps: this.props,
        Dialog: Dialog,
        hideScrollBar: hideScrollBar,
        className: !useNewUI ? (0, _classnames["default"])('modal-dialog spaui-dialog', className, _defineProperty({
          'modal-toast': type === 'tip',
          'ani-disappear': enabledTipAnimation && tipExitAnimation,
          'modal-toast-colorized': type === 'tip' && enabledBackgroundColor,
          'modal-simple': type === 'simple',
          'modal-confirm': type === 'confirm',
          'modal-normal': type === 'normal',
          'with-dialog-title': title,
          'spaui-dialog-nofooter': hideFooter && type !== 'confirm',
          'with-empty-footer': !cancelButton && !submitButton && !FooterLeftComponent
        }, "".concat(tipAnimationType, "-").concat(tipAnimationDirection), type === 'tip' && enabledTipAnimation && tipEnterAnimation)) : className,
        show: show,
        onClose: this.handleClose,
        onSubmit: this.handleSubmit,
        onCancel: this.handleCancel,
        ref: function ref(el) {
          _this4.dialogRef = el;
        }
      }), children);
    }
  }]);

  return Dialog;
}(_react.PureComponent); // 组件标记


_defineProperty(Dialog, "propTypes", _dialog_props.propTypes);

_defineProperty(Dialog, "defaultProps", _dialog_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Dialog, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');

if (typeof _spauiUtils.genDecorate !== 'undefined') {
  (0, _spauiUtils.genDecorate)(Dialog);
}

var _default = Dialog;
exports["default"] = _default;